import classNames from 'classnames';
import { useSalesCounterpartLabel } from 'components/shared/compact-selector/use-toggle-button';
import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import { FC } from 'react';

export interface ClientSearchButtonProps {
  selectedClient: Nullable<ISalesCounterpart>;
  onSearchClick: () => void;
  onRemoveClick: () => void;
}

export const ClientSearchButton: FC<ClientSearchButtonProps> = ({ selectedClient, onSearchClick, onRemoveClick }) => {
  const label = useSalesCounterpartLabel(selectedClient, false, 'form.Client.select');

  return (
    <button
      type="button"
      data-e2e="product-selector-client-search"
      className={classNames('btn btn-xl btn-default btn-icon-start', {
        'text-info btn-icon-end': selectedClient,
      })}
      onClick={onSearchClick}
    >
      <div className="d-flex overflow-hidden text-nowrap">
        <em className="icon">person</em>
        <span className="overflow-hidden ms-2">{label}</span>
      </div>
      {selectedClient && (
        <button
          type="button"
          className="btn btn-icon btn-flat-info"
          onClick={e => {
            e.stopPropagation();
            onRemoveClick();
          }}
        >
          <em className="icon">cancel</em>
        </button>
      )}
    </button>
  );
};
